import React from 'react';
import { connect } from 'react-redux';

import { togglePopup } from 'apps/auth/actions/appAction';
import { updateFormProperties } from 'apps/auth/actions/formAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { RESET_PASSWORD_ACTION, RESTORE_PASSWORD } from 'apps/auth/constants/UrlConstants';

export const ForgotPopup = (props) => {
    return (
        <SimplePopup withoutBorder>
            <PopupButton
                dataTestId="forgot-popup-link-restore-password"
                href="/restorepassword"
                tabIndex="1003"
                iconName="retry"
                text={props.passwordPopupRemind}
                onClick={(e) => {
                    e.preventDefault();
                    props.updateFormProperties(props.formName, RESTORE_PASSWORD, false).then(() => {
                        props.submitRef.current.disabled = false;
                        props.submitRef.current.click();
                        props.togglePopup(false);
                    });
                }}
            />
            <PopupButton
                dataTestId="forgot-popup-link-reset-password"
                href="/resetpassword.action"
                tabIndex="1004"
                iconName="arrow-forward"
                text={props.passwordSingUpSecCode}
                onClick={(e) => {
                    e.preventDefault();
                    props.updateFormProperties(props.formName, RESET_PASSWORD_ACTION, false).then(() => {
                        props.submitRef.current.disabled = false;
                        props.submitRef.current.click();
                        props.togglePopup(false);
                    });
                }}
            />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        passwordPopupRemind: state.messages.pageMessages.passwordPopupRemind,
        passwordSingUpSecCode: state.messages.pageMessages.passwordSingUpSecCode,
    };
};

export default connect(mapStateToProps, { togglePopup, updateFormProperties })(ForgotPopup);
